import { toCanvas } from 'qrcode';

export const makeQR = (text: string, container: HTMLElement) => {
  const width = container.offsetHeight;
  const canvas = document.createElement('canvas');
  container.appendChild(canvas);

  return toCanvas(canvas, text, { width } as any);
};
